'use strict';

/**
 * Amazing Nature — Grundpreis (PAngV) outside the price snippet.
 *
 * snippets/price.liquid renders the unit price next to every product price.
 * This file adds it in the three places that do not use that snippet:
 *   1. cart drawer line items (rebuilt by assets/cart.js on every update)
 *   2. cart page line items (.cp-item)
 *   3. mobile sticky add-to-cart bar on product pages
 *
 * Source of truth is Shopify's unit price on the variant (/cart.js returns
 * unit_price + unit_price_measurement per line, already reflecting Spar-Abo
 * and discounts). Nothing is calculated here.
 */
(() => {
  const CSS = `
    .unit-price { display: block; font-size: 12px; line-height: 1.4; font-weight: 400; color: var(--color-text-secondary); }
    .cart-item__price-wrap { flex-wrap: wrap; justify-content: flex-end; }
    .cart-item__price-wrap .unit-price { flex-basis: 100%; text-align: right; }
    .sticky-atc .unit-price { color: rgba(245,243,238,0.75); }
  `;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function unitLabel(item) {
    const m = item.unit_price_measurement;
    if (!m || item.unit_price == null) return '';
    const ref = (m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : '') + m.reference_unit;
    return formatMoney(item.unit_price) + ' / ' + ref;
  }

  function put(wrap, text) {
    if (!wrap) return;
    let el = wrap.querySelector('.unit-price');
    if (!text) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('span');
      el.className = 'unit-price';
      wrap.appendChild(el);
    }
    el.textContent = text;
  }

  function decorate(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const drawerRows = document.querySelectorAll('.cart-item');
    const pageRows = document.querySelectorAll('.cp-item');
    cart.items.forEach((item, index) => {
      const text = unitLabel(item);
      drawerRows.forEach(row => {
        if (row.dataset.key === item.key) put(row.querySelector('.cart-item__price-wrap'), text);
      });
      if (pageRows[index]) put(pageRows[index].querySelector('.cp-item__price'), text);
    });
  }

  function refresh() {
    if (!document.querySelector('.cart-item, .cp-item')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(resp => (resp.ok ? resp.json() : null))
      .then(decorate)
      .catch(() => {});
  }

  function stickyBar() {
    const source = document.querySelector('#ProductPrice .price__unit');
    const info = document.querySelector('[data-sticky-atc] .sticky-atc__info');
    if (!source || !info) return;
    const text = source.textContent.split('·')[0].replace('Grundpreis:', '').replace(/\s+/g, ' ').trim();
    put(info, text);
  }

  function init() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    stickyBar();
    refresh();
    /* cart.js re-renders the drawer on this event; wait until it is done. */
    document.addEventListener('cart:updated', () => setTimeout(refresh, 0));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
